import React from 'react';
import Image from '@components/Image';

interface BankLogo {
  code: string;
  name: string;
  value: string;
}

const imageBank: BankLogo[] = [
  {
    code: 'BCA_VA',
    name: 'BCA',
    value: 'bca-logo.webp',
  },
  {
    code: 'BRI_VA',
    name: 'BRI',
    value: 'bri-logo.webp',
  },
  {
    code: 'Sinarmas_VA',
    name: 'Sinarmas',
    value: 'sinarmas-logo.webp',
  },
  {
    code: 'Danamon_VA',
    name: 'Danamon',
    value: 'danamon-logo.webp',
  },
  {
    code: 'BSI_VA',
    name: 'BSI',
    value: 'bsi-logo.webp',
  },
  {
    code: 'BTN_VA',
    name: 'BTN',
    value: 'btn-logo.webp',
  },
  {
    code: 'BNC_VA',
    name: 'NEO BANK',
    value: 'bnc-logo.webp',
  },
  {
    code: 'BNC_VA',
    name: 'NEO BANK',
    value: 'bnc-logo.png',
  },
  {
    code: 'MAYBANK_VA',
    name: 'MAYBANK',
    value: 'may-logo.webp',
  },
  {
    code: 'MANDIRI_VA',
    name: 'MANDIRI',
    value: 'mandiri-logo.webp',
  },
  {
    code: 'CIMB_VA',
    name: 'CIMB',
    value: 'cimb.webp',
  },
  {
    code: 'PERMATA_VA',
    name: 'PERMATA',
    value: 'permata-logo.webp',
  },
  {
    code: 'BNI_VA',
    name: 'BNI',
    value: 'bni-logo.webp',
  },
  {
    code: 'CC',
    name: 'Bayarind Cards',
    value: 'bayarin.webp',
  },
  {
    code: 'CC',
    name: 'Doku Cards',
    value: 'doku.webp',
  },
  {
    code: 'CC',
    name: 'Credit Card',
    value: 'ccbanknew-logo.webp',
  },
  {
    code: 'SHOPEEPAY',
    name: 'SHOPEEPAY',
    value: 'sp-logo.webp',
  },
  {
    code: 'DANA',
    name: 'DANA',
    value: 'dana-logo.webp',
  },
  {
    code: 'OVO',
    name: 'OVO',
    value: 'ovo-logo.webp',
  },
  {
    code: 'LINKAJA',
    name: 'LINK AJA',
    value: 'link.webp',
  },
  {
    code: 'SPEEDCASH',
    name: 'SPEEDCASH',
    value: 'speedcash.webp',
  },
  {
    code: 'DD',
    name: 'BTN',
    value: 'btn.webp',
  },
  {
    code: 'BTN',
    name: 'BTN',
    value: 'btn.webp',
  },
  {
    code: 'CC',
    name: 'Credit Card',
    value: 'ccbanknew-logo.png',
  },
  {
    code: 'SHOPEEPAY',
    name: 'SHOPEEPAY',
    value: 'sp-logo.png',
  },
  {
    code: 'DANA',
    name: 'DANA',
    value: 'dana-logo.png',
  },
  {
    code: 'OVO',
    name: 'OVO',
    value: 'ovo-logo.png',
  },
  {
    code: 'LINKAJA',
    name: 'LINK AJA',
    value: 'link.png',
  },
  {
    code: 'QRIS',
    name: 'QRIS',
    value: 'qris.webp',
  },
  {
    code: 'visa-card',
    name: 'VISA',
    value: 'visa-card.webp',
  },
  {
    code: 'mastercard-card',
    name: 'MASTERCARD',
    value: 'mastercard-card.webp',
  },
  {
    code: 'maestro-card',
    name: 'MAESTRO',
    value: 'maestro-card.webp',
  },
  {
    code: 'jcb-card',
    name: 'JCB',
    value: 'jcb-card.webp',
  },
  {
    code: 'gpn-card',
    name: 'GPN',
    value: 'gpn-card.webp',
  },
  {
    code: 'unionpay-card',
    name: 'UNIONPAY',
    value: 'unionpay-card.webp',
  },
  {
    code: 'american_express-card',
    name: 'AMERICAN EXPRESS',
    value: 'american_express-card.webp',
  },
];

interface RenderBankLogoProps {
  title: string;
  idx?: number;
  width?: string;
  height?: string;
  name?: string;
}

const RenderBankLogo: React.FC<RenderBankLogoProps> = ({
  title,
  idx,
  width,
  height,
  name,
}) => {
  const normalizedTitle = title?.toLowerCase();
  const normalizedName = name?.toLowerCase();

  const matchingItemByName = normalizedName
    ? imageBank.find(
        (bank: BankLogo) =>
          bank.code.toLowerCase() === normalizedTitle &&
          bank.name.toLowerCase() === normalizedName
      )
    : undefined;

  const matchingItem =
    matchingItemByName ||
    imageBank.find(
      (bank: BankLogo) => bank.code.toLowerCase() === normalizedTitle
    );

  if (!title || !matchingItem) {
    return (
      <div className="py-2" key={idx}>
        <div className="flex w-full flex-row items-center">
          <span className="ml-2 text-xs font-bold">
            {title?.toUpperCase() ?? '-'}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      key={idx}
      className={`${width ? width : 'w-[50px] md:w-[70px]'} ${
        height ? height : 'h-[25px]'
      }`}
    >
      <Image
        className="h-full w-full object-contain"
        src={`/images/logos/webp/${matchingItem.value}`}
        alt={`${matchingItem.name} icon`}
      />
    </div>
  );
};

const RenderBankLogoName: React.FC<RenderBankLogoProps> = ({
  title,
  idx,
  name,
}) => {
  const normalizedTitle = title?.toLowerCase();
  const normalizedName = name?.toLowerCase();

  const matchingItemByName = normalizedName
    ? imageBank.find(
        (bank: BankLogo) =>
          bank.code.toLowerCase() === normalizedTitle &&
          bank.name.toLowerCase() === normalizedName
      )
    : undefined;

  const matchingItem =
    matchingItemByName ||
    imageBank.find(
      (bank: BankLogo) => bank.code.toLowerCase() === normalizedTitle
    );

  if (!title || !matchingItem) {
    return (
      <div className="py-2" key={idx}>
        <div className="flex w-full flex-row items-center">
          <span className="ml-2 text-xs font-medium">
            {title?.toUpperCase() ?? '-'}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-row items-center gap-3" key={idx}>
      <div className="aspect-[3/1] min-h-[46px] w-full max-w-[130px] rounded-lg border border-gray-300 bg-white px-1 py-1.5">
        <Image
          className="h-full w-full object-contain"
          src={`/images/logos/webp/${matchingItem.value}`}
          alt={`${matchingItem.name} icon`}
        />
      </div>
      <div className="block text-base font-medium capitalize">
        {name
          ? name.toLocaleLowerCase()
          : matchingItem.name.toLocaleLowerCase()}
      </div>
    </div>
  );
};

export { RenderBankLogo, RenderBankLogoName };
